import { render, staticRenderFns } from "./setVerbalTrick.vue?vue&type=template&id=81eeb8e0&scoped=true"
import script from "./setVerbalTrick.vue?vue&type=script&lang=js"
export * from "./setVerbalTrick.vue?vue&type=script&lang=js"
import style0 from "./setVerbalTrick.vue?vue&type=style&index=0&id=81eeb8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eeb8e0",
  null
  
)

export default component.exports